import { render, staticRenderFns } from "./EditServiceItemTable.vue?vue&type=template&id=cf8c152a&scoped=true"
import script from "./EditServiceItemTable.vue?vue&type=script&lang=js"
export * from "./EditServiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./EditServiceItemTable.vue?vue&type=style&index=0&id=cf8c152a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8c152a",
  null
  
)

export default component.exports